<template>
    <div>
        <div class="voucher-header border-line">
            <div class="voucher-container mx-auto">
                <div class="text-center text-16 text-a-gray-666666">
                    <div class="font-SemiBold text-a-black-080909">{{lbl.paywithpoint.create_voucher}}</div>
                    <!-- <div class="font-Text pt-1 break-words px-10">{{blobConfig.query.locale == 1033 ? blobConfig.campaign.detailEN : blobConfig.campaign.detail}}</div> -->
                    <div class="font-Text pt-1 break-words px-10">{{ getRateConvertText() }}</div>
                    <div class="text-14 text-a-gray-aaaaaa pt-1">{{getMinimumText()}}</div>
                </div>
            </div>
        </div>
        <div class="voucher-container mx-auto pb-24" v-if="loaded">
            <div class=" pt-5 text-center">
                <div class="text-14 px-6 cursor-pointer flex" :style="textStyle" @click="togglePointUnit()">
                    <div class="mr-1 ml-auto underline">{{lbl.paywithpoint.switch_unit}}</div>
                    <img class="mr-0 ml-0" :src="getSwitchImage()"/>
                </div>
                <div class="font-SemiBold text-16 text-a-black-080909">{{lbl.paywithpoint.points_amount}}</div>
                <InputNumber v-if="isPointUnit"
                    :style="textStyle"
                    v-model:inputValue="inputValue"
                    :maxLength="5"
                    :errorInfo="errorInputInfo[0]"
                    :isShowError="isShowError"
                    :isSubmitted="isSubmitted"
                    :inputLbl="lbl.paywithpoint.inputLbl"
                    :enableFocusCheck="true"
                    :disabled="isDisabled"
                    :showDefaultValue="0"
                    @update:inputValue="convert($event)"
                    ref="elemInput"
                    ></InputNumber>
                <InputNumber v-else
                    :style="textStyle"
                    v-model:inputValue="inputValue"
                    :maxLength="5"
                    :errorInfo="errorInputInfo[0]"
                    :isShowError="isShowError"
                    :isSubmitted="isSubmitted"
                    :inputLbl="lbl.paywithpoint.inputLblBaht"
                    :enableFocusCheck="true"
                    :disabled="isDisabled"
                    :showDefaultValue="0"
                    @update:inputValue="convert($event)"
                    ref="elemInput"
                    ></InputNumber>
            </div>
            <div class="flex flex-wrap space-x-2 px-5">
                <div class="border border-a-gray-cccccc px-5 py-1 cursor-pointer rounded-full"
                    v-for="(point,index) in rate.PointJson"
                    :key="index"
                    @click="selectValue(point.value)">
                    +{{getValueInput(point.value)}}
                </div>
            </div>
            <div class=" pt-12">
                <img class=" pt-0.5 h-5 mx-auto" :src="getConvertImg()"/>
            </div>
            <div class="px-6">
                <div class=" pt-11 text-center text-a-black-080909 font-SemiBold">{{lbl.paywithpoint.code_value}}</div>
                <div class="pt-2.5">
                    <div class="text-center py-3 rounded-full overflow-hidden  text-26 relative h-14"
                        >
                        <div class="absolute h-14 top-0 left-0 w-full opacity-20" :style="backgroundStyle"></div>
                        <div class="absolute h-14 top-0 left-0 w-full py-3">
                            {{toValue}}
                        </div>
                        <div class="absolute right-5 top-0 text-a-gray-666666 text-18 py-4" 
                            v-if="isPointUnit">{{lbl.paywithpoint.baht}}</div>
                        <div class="absolute right-5 top-0 text-a-gray-666666 text-18 py-4" 
                            v-else>{{lbl.paywithpoint.point}}</div>
                    </div>
                </div>
            </div>
            <OrangeButton :lbl="lbl" :blobConfig="blobConfig" @clickButton="clickRedeem()"></OrangeButton>
        </div>
    </div>
</template>
<script>
import { ref  , onMounted} from "vue"
import Util from "@/helper/Utility.js";
import { FormHelper } from '@/helper/FormHelper'
import InputNumber from '../input/InputNumber.vue'
import OrangeButton from '../Button/OrangeButton.vue'

import { RedeemConfigBuilder } from "@/core/Redeem/config/RedeemConfigBuilder";
import { SerialModel } from "@/core/Redeem/model/SerialModel";

import Service from '../../service/TransferPointService.js'
import mongoService from "../../../../service/mongoService"; 

import CreateQRModel from "../../model/CreateQRModel";

export default {
    name: 'Voucher',
    props: {
        lbl: Object,
        blobConfig: { type: Object },
        rate: { type: Object },
        modalController: { type: Object },
        paymentState: { type: Object },
    },
    components: {
        InputNumber,
        OrangeButton,
    },
    setup: function (props) {
        let isPointUnit = ref(true)
        let textStyle = ref(null)
        let backgroundStyle = ref(null)
        let currentPoint = 0
        let point = 0;
        let price = 0;
        let inputValue = ref(0)
        let toValue = ref(0)
        let errorInputInfo = ref(FormHelper.genErrorInfo(1))
        let isShowError = ref(true)
        let isSubmitted = ref(true)
        let isError = ref(true)
        let pointDetail = ref(null)
        let states = ref(null)
        let selectedQuantity = ref(null)
        let redeemConfigBuilder = ref(null)
        let isDisabled = ref(false)
        let loaded = ref(false)
        let convertLoaded = ref(false)
        const elemInput = ref(null)

        // const isCitiLine = computed(() => {
        //     if (props.blobConfig.query.appName == "citilinebc") {
        //         return true;
        //     }else{
        //         return false
        //     }
        // })
       
        const togglePointUnit = () => {
            isPointUnit.value = !isPointUnit.value

            //if paymentstate have limit point don't reset it
            inputValue.value =  isDisabled.value ? toValue.value : 0;
            convert()
        }

        const setupTheme = () => {
            textStyle.value = {
                color: props.blobConfig.appConfig.blobConfig.text_color
            }
            backgroundStyle.value = {
                backgroundColor: props.blobConfig.appConfig.blobConfig.btn_color
            }
        }

        const init = () => {
            // # enabled this comment ot enable socket io
            // socketQrPayment().then(() => {
                if (props.blobConfig.query.appName == "lineCiti") {
                    currentPoint = props.blobConfig.citiPoint.balance
                } else {
                    currentPoint = props.rate.CurrentPoints
                }
    
                setInputValue()
            // })
        }

        const setInputValue = () => {
            if(props.paymentState?.pointToUse != null){
                isDisabled.value = true
            }

            inputValue.value = props.paymentState?.pointToUse || ''
            loaded.value = true
        }

        const getConvertImg = () => {
            return `${props.blobConfig.blobUrl}/image/${props.blobConfig.appConfig.blobConfig.icon_convert}`;
        }

        const getValueInput = (valueInput) => {
            if (isPointUnit.value) {
                return valueInput
            } else {
                return valueInput * props.rate.ConvertRate
            }
        }

        const selectValue = (valueInput) => {
            inputValue.value = inputValue.value + getValueInput(valueInput)
            elemInput.value.onUpdatePoint(inputValue.value)
            convert()
        }

        const convert = (firstTimeInit = false) => {
            isSubmitted.value = firstTimeInit? false : true
            if(firstTimeInit && inputValue.value == ''){
                inputValue.value = 0
            }

            if (isPointUnit.value) {
                calculatePrice()
            } else {
                calculatePoint()
            }

            convertLoaded.value = true

        }

        const calculatePoint = () => {
            price = inputValue.value / props.rate.ConvertRate
            price = Math.floor(price)
            toValue.value = price
            if(isNaN(toValue.value)){
                toValue.value = ''
            }
            inputValue.value = toValue.value * props.rate.ConvertRate
            point = inputValue.value
            elemInput.value.onUpdatePoint(inputValue.value)
            if (inputValue.value > currentPoint) {
                inputValue.value = currentPoint
                calculatePoint()
            } else {
                validate()
            }
            
        }

        const calculatePrice = () => {
            price = inputValue.value
            
            let priceCheck = price * props.rate.ConvertRate
            if(isNaN(priceCheck)){
                toValue.value = ''
            }

            if(priceCheck.toString().includes(".")){
                // priceCheck = Math.floor(priceCheck)
            }

            if (priceCheck > currentPoint) {
                price = currentPoint * props.rate.ConvertRate
                price = Math.floor(price)
                inputValue.value = price
                toValue.value = inputValue.value /  props.rate.ConvertRate
                point = inputValue.value
                elemInput.value.onUpdatePoint(inputValue.value)
                validate()
            } else {
                toValue.value = priceCheck
                elemInput.value.onUpdatePoint(inputValue.value)
                point = inputValue.value
                validate()
            }
        }

        const validate = () => {
            let errMsg = ""
     
            console.log("🚀 ~ validate ~ point:", point)
            console.log('case1',props.rate.MinimumPoint && point < getMinimumRate())
            console.log('case2',props.rate.MaximumPoint && point > getMaximumPointRate())
            if (props.rate.MinimumPoint && point < getMinimumRate()) {
                errMsg = Util.stringFormat(props.lbl.err.err_min_point, getMinimumRate())
            } else if (props.rate.MaximumPoint && point > getMaximumPointRate()) {
                errMsg = Util.stringFormat(props.lbl.err.err_max_point, getMaximumPointRate())
            } else if (props.rate.LimitPerAppRemaining == 0) {
                errMsg = props.lbl.err.err_limit_soldout
            } else if (props.rate.LimitPerUserRemaining == 0) {
                errMsg = props.lbl.err.err_limit_peruser
            } else if (props.rate.LimitPerAppRemaining && point > props.rate.LimitPerAppRemaining) {
                if (isPointUnit.value) {
                    errMsg = Util.stringFormat(props.lbl.err.err_limit_app_point, props.rate.LimitPerAppRemaining)
                } else {
                    errMsg = Util.stringFormat(props.lbl.err.err_limit_app_point, props.rate.LimitPerAppRemaining * props.rate.ConvertRate)
                }
            } else if (props.rate.LimitPerUserRemaining && point > props.rate.LimitPerUserRemaining) {
                if (isPointUnit.value) {
                    errMsg = Util.stringFormat(props.lbl.err.err_limit_user_point, props.rate.LimitPerUserRemaining)
                } else {
                    errMsg = Util.stringFormat(props.lbl.err.err_limit_user_point, props.rate.LimitPerUserRemaining * props.rate.ConvertRate)
                }
            
            } 

            if (errMsg != '') {
                elemInput.value.onUpdateError(errMsg)
                // props.modalController.alertModal
                //         .clearModal()
                //         .setTitle(props.lbl.alert.redeem_title)
                //         .setMsg(props.lbl.alert.redeem_msg)
                //         .setBtnCancel(props.lbl.alert.close_btn)
                //         .show()
                isError.value = true
            } else {
                isError.value = false
            }
        }

        // Redeem State

        const clickRedeem = () => {
            isSubmitted.value = true
            if (isError.value) return

            let data = {
                point: point,
                pointConvert: price
            }

            pointDetail.value = data
            // ctx.emit('clickButton', data); //for updaate point detail
            

            confirmRedeem();
        }

        function confirmRedeem() {
            props.modalController.confirmModal
                .clearModal()
                .setTitle(props.lbl.confirm_popup.confirm_create)
                .setMsg(pointDetail.value)
                .setBlobConfig(props.blobConfig)
                .setBtnCancel(props.lbl.confirm_popup.cancel_btn)
                .setBtnOk(props.lbl.confirm_popup.confirm_btn)
                .show()

            props.modalController.confirmModal.onClickOk(() => {
                redeemConfigBuilder.value = new RedeemConfigBuilder();
                states.value = props.blobConfig;
                selectedQuantity.value = pointDetail.value.point;
                console.log(selectedQuantity.value)
            
                // Check if paymentQrSate or not
                if(props.paymentState != null){
                    redeemQrPayment();
                }else{
                    redeem();
                }
            });
        }

        function redeem() {
            props.modalController.loadingModal.show()
            let redeemParams = new CreateQRModel();
            const profile = props.blobConfig.profile.profile
            const appId = props.blobConfig.query.appId;
            const userId = profile.userId;
            const appMain = props.blobConfig.mainAppName;
            const wtoken = props.blobConfig.query.wallet_token;
            const apiPrefix = props.blobConfig.query.apiPrefix;
            const weblandingBlob = props.blobConfig.blobWebLanding;
            const walletCardId = props.blobConfig.query.walletCardId;
            const isDeductBzbsApp = !walletCardId ? true : props.blobConfig.query.isDeductBzbsApp
            // const amount = !isNaN(selectedQuantity.value) && selectedQuantity.value > 0 ? selectedQuantity.value : null
            const amount = toValue.value

            redeemParams.setDataFromObject({
                appId : appId,
                userId : userId,
                cardId : props.blobConfig.query.walletCardId || null,
                isDeductBzbsApp : isDeductBzbsApp,
                amount: amount
            }); 
            let params = redeemParams.getParams()

            var theme = props.blobConfig.query.theme || "";
            var appName = props.blobConfig.query.appName || theme || "";

            // var isDeductBzbsApp = props.blobConfig.query.isDeductBzbsApp;
            Service.apiGenQrCode(appMain, wtoken, apiPrefix, weblandingBlob, params, null, props.blobConfig, isDeductBzbsApp).subscribe({
                next: (res) => {  
                    props.modalController.loadingModal.hide()
                    // redeemSuccess(false);
                    showSerialQR(res, amount);
                    mongoService.sendSuccessLogMongoDb(appName, theme, params, res);  
                },
                error: (err) => {
                    console.log(err);
                    props.modalController.loadingModal.hide()
                    props.modalController.alertModal
                        .clearModal()
                        .setTitle(props.lbl.alert.redeem_title)
                        .setMsg(props.lbl.alert.redeem_msg)
                        .setBtnCancel(props.lbl.alert.close_btn)
                        .show()
                    mongoService.sendErrorLogMongoDb(err.err, params, appName, theme); 
                },
            })
        }

        function redeemQrPayment(){
            console.log(props.blobConfig)
            props.modalController.loadingModal.show()
            const appMain = props.blobConfig.mainAppName;
            const wtoken = props.blobConfig.query.wallet_token;
            const apiPrefix = props.blobConfig.query.apiPrefix;
            const weblandingBlob = props.blobConfig.blobWebLanding;
            const walletCardId = props.blobConfig.query.walletCardId;
            const isDeductBzbsApp = !walletCardId ? true : props.blobConfig.query.isDeductBzbsApp

            var params = {
                qrId: props.paymentState.qrID,
                detail: null,
                amount: selectedQuantity.value || null,
                isDeductBzbsApp: isDeductBzbsApp,
                cardId : props.blobConfig.query.walletCardId || null,
            }

            var theme = props.blobConfig.query.theme || "";
            var appName = props.blobConfig.query.appName || theme || "";

            Service.apiRedeemPayQrUser(appMain, wtoken, apiPrefix, weblandingBlob, params).subscribe({
                next: (res) => {  
                    console.log(res);
                    props.modalController.loadingModal.hide()
                    redeemSuccess();
                    mongoService.sendSuccessLogMongoDb(appName, theme, params, res);  
                },
                error: (err) => {
                    console.log(err);
                    props.modalController.loadingModal.hide()
                    props.modalController.alertModal
                        .clearModal()
                        .setTitle(props.lbl.alert.redeem_title)
                        .setMsg(props.lbl.alert.redeem_msg)
                        .setBtnCancel(props.lbl.alert.close_btn)
                        .show()
                    mongoService.sendErrorLogMongoDb(err.err, params, appName, theme); 
                },
            })
        }

        function redeemSuccess() {
            props.modalController.successModal
                    .clearModal()
                    .setTitle(props.lbl.redeem_success.create_success)
                    .setMsg(props.lbl.redeem_success.detail)
                    .setBlobConfig(props.blobConfig)
                    .setBtnOk(props.lbl.redeem_success.use_btn)
                    .show()
        }

        function showSerialQR(serialData, point) {
            var serial = new SerialModel();
                serial.setModelFromDataModel(serialData);
            props.modalController.serialModal
                    .clearModal()
                    .setSerial(serial)
                    .setStates(props.blobConfig)
                    .setValue(point)
                    .show()

            props.modalController.serialModal.onCloseModal(() => {
                // showConfirmClose();
            })

            props.modalController.serialModal.onScanSuccess((res) => {
                console.log(res)
                props.modalController.successModal
                        .clearModal()
                        .setTitle(props.lbl.redeem_success.qr_redeem_success)
                        .setMsg(props.lbl.redeem_success.qr_redeem_success_detail)
                        .setBlobConfig(props.blobConfig)
                        .setBtnOk(props.lbl.base_button.close)
                        .show()
            })

            props.modalController.serialModal.onScanError((res) => {
                console.log(res)
                // used same ui as success modal
                props.modalController.successModal
                        .clearModal()
                        .setTitle(props.lbl.redeem_success.qr_redeem_error)
                        .setMsg(props.lbl.redeem_success.qr_redeem_error_detail)
                        .setBlobConfig(props.blobConfig)
                        .setBtnOk(props.lbl.base_button.close)
                        .show()
            })
        }

        // function showConfirmClose() {
        //     props.modalController.alertModal
        //             .clearModal()
        //             .setMsg(props.lbl.alert.close_Showcode_msg)
        //             .setBtnCancel(props.lbl.alert.close_btn)
        //             .show()
        //     props.modalController.alertModal.onClickCancel(() => {
        //         window.location.reload()
        //     })
        // }

        // end of Redeem state

        const getMinimumText = () => {
            if (isPointUnit.value) {
                return Util.stringFormat(props.lbl.paywithpoint.minimum_point,props.rate.MinimumPoint || '')
            } else {
                return Util.stringFormat(props.lbl.paywithpoint.minimum_bath,props.rate.MinimumPoint * props.rate.ConvertRate || '')
            }
        }

        const getMinimumRate = () => {
            if (isPointUnit.value) {
                return props.rate.MinimumPoint
            } else {
                return props.rate.MinimumPoint * props.rate.ConvertRate
            }
        }

        const getMaximumPointRate = () => {
            if (isPointUnit.value) {
                return props.rate.MaximumPoint
            } else {
                return props.rate.MaximumPoint * props.rate.ConvertRate
            }
        }

        const getConvertRate = () => {
            // if (props.blobConfig.query.appName == "lineCiti") {
            //     return  Math.floor(props.blobConfig.citiPoint.balance * 100)
            // } else {
                return  Math.floor(props.rate.ConvertRate * 100)
            // }
        }

        const getRateConvertText = () => {
            return `${getConvertRate()} ${props.lbl.paywithpoint.point} = 1 ${props.lbl.paywithpoint.baht}`
        }

        const getSwitchImage = () => {
            return `${props.blobConfig.blobUrl}/image/icon-switch.png`;
        }

        init()
        onMounted(()=> {
            convert(true)
            setupTheme()
        })

        return {
            isPointUnit,
            textStyle,
            backgroundStyle,
            getConvertImg,
            inputValue,
            toValue,
            errorInputInfo,
            isShowError,
            isSubmitted,
            isDisabled,
            loaded,
            convert,
            elemInput,
            clickRedeem,
            togglePointUnit,
            getValueInput,
            selectValue,
            getSwitchImage,
            getMinimumText,
            getRateConvertText,
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';

.voucher-container {
    min-height: max-content;
    max-width: $max-width-l-mobile;
}
.voucher-header {
    padding: 66px 0 14px;
    @include tablet {
        padding: 60px 0 14px;
    }
}
.font-SemiBold {
    font-family: $ff-semi;
}
.font-Text {
    font-family: $ff-text;
}
.border-line {
    border-bottom: 2px dashed;
    border-color: #cccccc;
}
</style>
